import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import ApiRequest from "./ApiRequest";
import { ApiEndpoints } from "./ApiEndpoints";

const PermissionContext = createContext({ status: "loading", permissionSlugs: new Set(), hasPermission: () => false, refreshPermissions: () => {} });
export const usePermissions = () => useContext(PermissionContext);

export function PermissionProvider({ children }) {
  const [status, setStatus] = useState("loading");
  const [permissionSlugs, setPermissionSlugs] = useState(new Set());
  const refreshPermissions = useCallback(async (initialPageLoad = false) => {
    try {
      const endpoint = initialPageLoad
        ? `${ApiEndpoints.rbac.myPermissions}?initial=1`
        : ApiEndpoints.rbac.myPermissions;
      const response = await ApiRequest("GET", endpoint);
      setPermissionSlugs(new Set((response.permissions || []).map(permission => permission.slug)));
      setStatus("ready");
    } catch (error) {
      if (error.response?.status !== 401) { setPermissionSlugs(new Set()); setStatus("ready"); }
    }
  }, []);
  useEffect(() => {
    refreshPermissions(true);
    const timer = window.setInterval(() => refreshPermissions(false), 5000);
    const onFocus = () => refreshPermissions(false);
    window.addEventListener("focus", onFocus);
    return () => { window.clearInterval(timer); window.removeEventListener("focus", onFocus); };
  }, [refreshPermissions]);
  const value = useMemo(() => ({ status, permissionSlugs, hasPermission: slug => status === "ready" && permissionSlugs.has(slug), refreshPermissions }), [status, permissionSlugs, refreshPermissions]);
  return <PermissionContext.Provider value={value}>{children}</PermissionContext.Provider>;
}
